/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Divider } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Preloader from 'src/components/Preloader';
import FadeIn from 'react-fade-in';
import useStyles from '../styles';

import ReviewData from './ReviewData';

const StepTwo = ({ data, handleBack, handleSubmit, loading }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const content = useMemo(() => {
    return !loading ? <ReviewData values={data} /> : <Preloader />;
  }, [loading]);

  const handleOtherSubmit = e => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <FadeIn>
      <form onSubmit={handleOtherSubmit}>
        <Divider light />
        {content}

        <Box
          className={classes.tableBox}
          display="flex"
          justifyContent={data.balance !== 0 ? 'space-between' : 'flex-end'}
          position="relative"
        >
          {data.balance !== 0 && (
            <Button
              className={classes.buttons}
              onClick={handleBack}
              color="primary"
              variant="outlined"
              disabled={loading}
            >
              {t('COMMON.BACK')}
            </Button>
          )}
          <Button
            className={clsx(classes.buttons, classes.buttonMain)}
            type="submit"
            color="primary"
            variant="outlined"
            disabled={loading}
          >
            {t('COMMON.ACCEPT')}
          </Button>
        </Box>
      </form>
    </FadeIn>
  );
};
StepTwo.propTypes = {
  data: PropTypes.object,
  handleBack: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool
};

export default StepTwo;
